import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IAPIListResult, IPagination, IPaginationResult } from "app/common/interfaces";
import { andAllWhere, andWhere, buildQuery, Normalizers, Ops, orderBy, OrderVariant, page, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { ICreateBankAccount } from "./interfaces/create-account.interface";
import { IUpdateBankAccount } from "./interfaces/update-account.interface";
import BankAccountAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/bank/bank-account/bank-account.entity";

const apiUrl = env.API_PAYMENT_MASTER_URL;
const moduleName = "bank_account";

@Injectable({
  providedIn: "root",
})
export class BankAccountService extends AbstractService<BankAccountAttributes, ICreateBankAccount, IUpdateBankAccount> {
    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    /**
     * List
     * @param filter CombinedFilter of related entity - BankAccountAttributes
     * @returns Data list
     */
    getAllBankAccount(bankId: string): Observable<IAPIListResult<BankAccountAttributes>> {
        const API_URL: string = apiUrl + `api/${moduleName}/${bankId}`;
        return this.http.get<IAPIListResult<BankAccountAttributes>>(API_URL);
    }
}
